import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ExpandableSection } from '../components/expandableSection';
import { PowerPlayerFeatureIndicator } from '../components/messageBoxes/settingsModal/powerPlayerFeatureIndicator';
import { StatsFieldsContents } from './playerInfoPanel/statsFieldsContents';
export const PlayerStatsExpandableSectionContainer = ({ isSelfPanel, statsFields }) => {
    const expandableSectionType = isSelfPanel ? 'self-stats' : 'player-stats';
    const contents = statsFields?.length ? (_jsx(StatsFieldsContents, { statsFields: statsFields })) : (_jsx(PowerPlayerFeatureIndicator, { powerPlayerBoltColor: 'black', isClickable: true }));
    return (_jsx(ExpandableSection, { expandableSectionType: expandableSectionType, colorType: 'player-info', children: contents }));
};
